import React, { Component } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-power-select/dist/react-power-select.css';
export default class PortalJobSplitter extends Component {
  constructor(props) {
    super(props);
    let jobId  = $('#job-splitter-modal').data('data-job-id');
    let that = this;
    this.state = {
      isLoading: true,
      job: props.data || [],
      jobId: jobId || null,
      originalPickupAddressOnOneLine: '',
      originalDropoffAddressOnOneLine: '',
    };
    this.handleCreateSplitButtonClick = this.handleCreateSplitButtonClick.bind(this);
    Echo.
    channel('jobs-table-'+jobId).
    listen('JobsTableChanged', (e) => {
      that.getJobSplittingDataForJob(jobId);
    });
  }
  handleCreateSplitButtonClick(e, jobId = null) {
    e.preventDefault();
    if (jobId == null) { return false; }
    this.splitJob(jobId);
  }
  splitJob(jobId = null) {
    if (!Number.isInteger(jobId)) {
      return false;
    }
    let that = this;
    this.setState({
      isLoading:true
    });
    $.ajax({
      url: "/api/v1/portal/job-splitting/split-job/"+jobId,
      data: {api_token: window.api_token},
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status == 200) {
          // ASSUME GOOD FOR NOW
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html(
            response.responseText.replace(/\"/g,
              "")
          );
          $('#infomodal').modal();
        }
        that.getJobSplittingDataForJob(that.state.jobId);
      }
    });
  }
  componentDidMount() {
    if (this.state.jobId) {
      this.getJobSplittingDataForJob(this.state.jobId);
    }
    
  }
  formatAddressAsOneLine(address, addressAsOneLine = '') {
    if (address.house_number_or_name != null) {
      addressAsOneLine = address.house_number_or_name;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.address_line_1 != null) {
      addressAsOneLine = addressAsOneLine+address.address_line_1;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.address_line_2 != null) {
      addressAsOneLine = addressAsOneLine+address.address_line_2;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.address_line_3 != null) {
      addressAsOneLine = addressAsOneLine+address.address_line_3;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.town_city != null) {
      addressAsOneLine = addressAsOneLine+address.town_city;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.county_area != null) {
      addressAsOneLine = addressAsOneLine+address.county_area;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.country != null) {
      addressAsOneLine = addressAsOneLine+address.country;
      addressAsOneLine = addressAsOneLine+', ';
    }
    if (address.postcode != null) {
      addressAsOneLine = addressAsOneLine+address.postcode;
    }
    return addressAsOneLine;
  }
  formatDriverTimeAsOneLine(preposition='', day='', month='', year='', time='') {
    return preposition+' '+day+'/'+month+'/'+year+' @ '+time;;
  }
  getJobSplittingDataForJob(jobId) {
    if (!Number.isInteger(jobId)) {
      return false;
    }
    let that = this;
      that.setState({isLoading: true});
    $.ajax({
      url: "/api/v1/portal/job-splitting/get-data-for-job/"+jobId,
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(jobDataJson) {
      that.setState({
        job: jobDataJson,
        originalPickupAddressOnOneLine: that.formatAddressAsOneLine(
          jobDataJson.pickup_address
        ),
        originalPickupTime: that.formatDriverTimeAsOneLine(
          jobDataJson.scheduled_pickup_preposition,
          jobDataJson.scheduled_pickup_day,
          jobDataJson.scheduled_pickup_month,
          jobDataJson.scheduled_pickup_year,
          jobDataJson.scheduled_pickup_time
        ),
        originalDropoffAddressOnOneLine: that.formatAddressAsOneLine(
          jobDataJson.dropoff_address
        ),
        originalDropoffTime: that.formatDriverTimeAsOneLine(
          jobDataJson.scheduled_dropoff_preposition,
          jobDataJson.scheduled_dropoff_day,
          jobDataJson.scheduled_dropoff_month,
          jobDataJson.scheduled_dropoff_year,
          jobDataJson.scheduled_dropoff_time),
        isLoading: false
      });
    });
  }

  renderSplitJobTree() {
    let i = 0;
    let splitJobStuff = [];
    let that = this;
    let iterateThroughTree = function(obj) {
      let i = 0;
      //for (i = 0; i < obj.split_job_child_recursive.length; i++) {
        //if (obj.split_job_child_recursive[i] !== null) {
         // if (obj.split_job_child_recursive[i].split_job_child_recursive.length === 0) {
            splitJobStuff.push(
              <JobSplit
                key={'split-job-'+obj.split_job_child_recursive[0].id}
                jobOneId={obj.split_job_child_recursive[0].id}
                jobTwoId={obj.split_job_child_recursive[1].id}
                jobOne={obj.split_job_child_recursive[0]}
                jobTwo={obj.split_job_child_recursive[1]}
                hasChildJobs={obj.split_job_child_recursive.length}
                pickupAddressOnOneLineChildOne={
                  that.formatAddressAsOneLine(
                    obj.split_job_child_recursive[0].pickup_address
                  )
                }
                pickupAddressOnOneLineChildTwo={
                  that.formatAddressAsOneLine(
                    obj.split_job_child_recursive[1].pickup_address
                  )
                }
                dropoffAddressOnOneLineChildOne={
                  that.formatAddressAsOneLine(
                    obj.split_job_child_recursive[0].dropoff_address
                  )
                }
                dropoffAddressOnOneLineChildTwo={
                  that.formatAddressAsOneLine(
                    obj.split_job_child_recursive[1].dropoff_address
                  )
                }
                pickupTimeChildOne={
                  that.formatDriverTimeAsOneLine(
                    obj.split_job_child_recursive[0].scheduled_pickup_preposition,
                    obj.split_job_child_recursive[0].scheduled_pickup_day,
                    obj.split_job_child_recursive[0].scheduled_pickup_month,
                    obj.split_job_child_recursive[0].scheduled_pickup_year,
                    obj.split_job_child_recursive[0].scheduled_pickup_time)
                }
                pickupTimeChildTwo={
                  that.formatDriverTimeAsOneLine(
                    obj.split_job_child_recursive[1].scheduled_pickup_preposition,
                    obj.split_job_child_recursive[1].scheduled_pickup_day,
                    obj.split_job_child_recursive[1].scheduled_pickup_month,
                    obj.split_job_child_recursive[1].scheduled_pickup_year,
                    obj.split_job_child_recursive[1].scheduled_pickup_time)
                }
                dropoffTimeChildOne={
                  that.formatDriverTimeAsOneLine(
                    obj.split_job_child_recursive[0].scheduled_dropoff_preposition,
                    obj.split_job_child_recursive[0].scheduled_dropoff_day,
                    obj.split_job_child_recursive[0].scheduled_dropoff_month,
                    obj.split_job_child_recursive[0].scheduled_dropoff_year,
                    obj.split_job_child_recursive[0].scheduled_dropoff_time)
                }
                dropoffTimeChildTwo={
                  that.formatDriverTimeAsOneLine(
                    obj.split_job_child_recursive[1].scheduled_dropoff_preposition,
                    obj.split_job_child_recursive[1].scheduled_dropoff_day,
                    obj.split_job_child_recursive[1].scheduled_dropoff_month,
                    obj.split_job_child_recursive[1].scheduled_dropoff_year,
                    obj.split_job_child_recursive[1].scheduled_dropoff_time)
                }
                handleCreateSplitButtonClick={
                  that.handleCreateSplitButtonClick.bind(this)
                }
               />);
         // }
          //else {
           // iterateThroughTree(obj.split_job_child_recursive[i]);
         // }
       // }
      //}
      return null
    };

    if (this.state.job.split_job_child_recursive.length === 0) {
      splitJobStuff.push(
        <SingltJobSplit
          key={'split-job-'+this.state.id}
          jobId={this.state.id}
          job={this.state.job}
          pickupAddressOnOneLine={
            this.formatAddressAsOneLine(this.state.job.pickup_address)
          }
          dropoffAddressOnOneLine={
            this.formatAddressAsOneLine(this.state.job.dropoff_address)
          }
          pickupTime={
            that.formatDriverTimeAsOneLine(
              this.state.job.scheduled_pickup_preposition,
              this.state.job.scheduled_pickup_day,
              this.state.job.scheduled_pickup_month,
              this.state.job.scheduled_pickup_year,
              this.state.job.scheduled_pickup_time)
          }
          dropoffTime={
            that.formatDriverTimeAsOneLine(
              this.state.job.scheduled_dropoff_preposition,
              this.state.job.scheduled_dropoff_day,
              this.state.job.scheduled_dropoff_month,
              this.state.job.scheduled_dropoff_year,
              this.state.job.scheduled_dropoff_time)
          }
          handleCreateSplitButtonClick={this.handleCreateSplitButtonClick.bind(this)}
         />);
    }
    else {
      iterateThroughTree(this.state.job);
    }
    return (
      <div className="portal-job-splitter-blocks-container">
      {splitJobStuff}
      </div>
    )
  }

  render() {
    return (
      <div>
      {this.state.isLoading ?
      (<div className="loading-box">
        <span className="add-loading-text">
          <i className="fa fa-spinner fa-pulse"></i>
        </span>
      </div>) :
        <form id="split_job_form" ref="splitJobForm" className="text-right">
          <fieldset>
            <div className="portal-job-splitter-blocks-container">
              <div className="portal-job-splitter-block portal-job-splitter-block-start portal-job-splitter-block-original-start">
                <div className="job-splitter-block-address-and-time">
                  <div>Pickup Address: {this.state.originalPickupAddressOnOneLine}</div>
                  <div>Pickup {this.state.originalPickupTime}</div>
                </div>
                <div className="job-splitter-block-address-and-time">
                  <div>Dropoff Address: {this.state.originalDropoffAddressOnOneLine}</div>
                  <div>Dropoff {this.state.originalDropoffTime}</div>
                </div>
                <div className="job-splitter-job-belongs-to-info">
                  (Original <a href={"/jobs/view/"+this.state.jobId}>Job#{this.state.jobId}</a> pickup)
                </div>
              </div>
            </div>
            {this.renderSplitJobTree()}
            <div className="portal-job-splitter-blocks-container">
              {/* <div className="portal-job-splitter-block portal-job-splitter-block-end portal-job-splitter-block-original-end">
                <div className="job-splitter-block-address-and-time">
                  <div>Pickup Address: {this.state.originalDropoffAddressOnOneLine}</div>
                  <div>Pickup {this.state.originalDropoffTime}</div>
                </div>
                <div className="job-splitter-job-belongs-to-info">
                  (Original <a href={"/jobs/view/"+this.state.jobId}>Job#{this.state.jobId}</a> dropoff)
                </div>
              </div> */}
            </div>
          </fieldset>
        </form>
      }
      </div>
    )
  }
}
class SingltJobSplit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      job: props.job || null,
      pickupAddressOnOneLine: props.pickupAddressOnOneLine || null,
      dropoffAddressOnOneLine: props.dropoffAddressOnOneLine || null,
      pickupTime: props.pickupTime || null,
      dropoffTime: props.dropoffTime || null,
      hasChildJobs:props.hasChildJobs || 0,
    }
  }
  render() {
    return (
      <div className="portal-job-splitter-blocks-container row">
        <div className="col-md-12 text-center">
          <button className="btn btn-info btn-lg" onClick={(e) => this.props.handleCreateSplitButtonClick(e, this.state.job.id)}>
            <i className="fa fa-strikethrough"></i>plit
          </button>
        </div>
        <div className="col-md-6">
          <div className="portal-job-splitter-block portal-job-splitter-block-start">
            <div className="job-splitter-block-address-and-time">
              <div>Pickup Address: {this.state.pickupAddressOnOneLine}</div>
              <div>Pickup {this.state.pickupTime}</div>
            </div>
            <div className="job-splitter-job-belongs-to-info">
              (<a href={"/jobs/view/"+this.state.job.id}>Job#{this.state.job.id}</a> pickup)
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="portal-job-splitter-block portal-job-splitter-block-end">
            <div className="job-splitter-block-address-and-time">
              <div>Dropoff {this.state.dropoffTime}</div>
              <div>Dropoff Address: {this.state.dropoffAddressOnOneLine}</div>
            </div>
            <div className="job-splitter-job-belongs-to-info">
              (<a href={"/jobs/view/"+this.state.job.id}>Job#{this.state.job.id}</a> dropoff)
            </div>
          </div>
        </div>
      </div>
    )
  }
}
class JobSplit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      jobOne: props.jobOne || null,
      jobTwo: props.jobTwo || null,
      pickupAddressOnOneLineChildOne: props.pickupAddressOnOneLineChildOne || null,
      pickupAddressOnOneLineChildTwo: props.pickupAddressOnOneLineChildTwo || null,
      dropoffAddressOnOneLineChildOne: props.dropoffAddressOnOneLineChildOne || null,
      dropoffAddressOnOneLineChildTwo: props.dropoffAddressOnOneLineChildTwo || null,
      pickupTimeChildOne: props.pickupTimeChildOne || null,
      pickupTimeChildTwo: props.pickupTimeChildTwo || null,
      dropoffTimeChildOne: props.dropoffTimeChildOne || null,
      dropoffTimeChildTwo: props.dropoffTimeChildTwo || null,
      hasChildJobs:props.hasChildJobs || 0
    }
    this.handleFirstChildAddressSave = this.handleFirstChildAddressSave.bind(this);
  }
  componentDidMount() {
    let that = this;

    const lookups = [
      {
        containerId: '#dropoff_address_postcode_lookup_split',
        output: {
          line_1: '#dropoff_address_address_line_1_split',
          line_2: '#dropoff_address_address_line_2_split',
          line_3: '#dropoff_address_address_line_3_split',
          post_town: '#dropoff_address_town_city_split',
          county: '#dropoff_address_county_area_split',
          postcode: '#dropoff_address_postcode_split'
        },
        phoneField: 'dropoff_phone',
        processingDiv: 'dropoff_address_postcode_lookup_split'
      }
    ];

    lookups.forEach((config) => {

      const $container = $(config.containerId);

      if (!$container.length) {
        return;
      }

      const btnId = config.containerId.replace('#', '') + '_btn';
      const contextId = config.containerId.replace('#', '') + '_context';
      const groupId = config.containerId.replace('#', '') + '_group';

      const html = `
            <div class="input-group mb-2" id="${groupId}">
                <div class="input-group-append">
                    <button
                        class="btn btn-lg btn-default"
                        style="z-index:0;"
                        type="button"
                        id="${btnId}">
                        Find Address
                    </button>
                </div>
            </div>

            <div id="${contextId}"></div>
        `;

      $container.html(html);

      IdealPostcodes.PostcodeLookup.setup({

        apiKey: 'ak_mmdm3rhaq0wIeQm7rcSauiGCxqNJM',

        context: '#' + contextId,

        button: '#' + btnId,

        outputFields: config.output,

        onLoaded: function () {

          const $context = $(this.context);

          const $input = $context.find('input');

          if ($input.length) {

            $input.addClass('form-control form-control-lg');

            $input.attr('placeholder', 'Enter Postcode');

            $('#' + groupId).prepend($input);
          }

          $('#' + btnId).css({
            width: '80%'
          });

          const $select = $context.find('select');

          if ($select.length) {

            $select.addClass('form-control form-control-lg mt-2');

            $select.css({
              height: '40px'
            });
          }
        },

        onAddressSelected: (address) => {

          const formattedAddress = [
            address.line_1,
            address.line_2,
            address.line_3,
            address.post_town,
            address.county,
            address.postcode
          ]
            .filter(Boolean)
            .join(', ');

          this.callGetPlaceFinderFunc(
            formattedAddress,
            config.phoneField,
            config.processingDiv
          );
        }
      });
    });

  }
  callGetPlaceFinderFunc(selectedAddress,PhoneNumberField,processingDiv){
    var service = new google.maps.places.PlacesService($('#place-service-helper-div-split').get(0)); // note that it removes the content inside div with tag '#service-helper'
    var request = {
      query: selectedAddress,
      fields: ['place_id','name'],
    };
    $('#'+processingDiv).after('<span class="postcode-lookup-processing">Processing..</span>');
    service.findPlaceFromQuery(request, function(results, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        service.getDetails({placeId: results[0].place_id}, function(place, status) {
             if (status === google.maps.places.PlacesServiceStatus.OK) {
               $('#'+PhoneNumberField).val(place.formatted_phone_number);
             }else{ 
               console.log('unable to find phone number by selected palce: ',status);
             }
             $('.postcode-lookup-processing').remove();
         });
      }else{
        console.log('unable to find place by query: ',status);
      }
    });
  }
  handleFirstChildAddressSave(e){
    e.preventDefault();
    let jobId = this.state.jobOne.id;
    let firstChildSplit =  this.state.jobOne.id;
    let secondChildSplit =  this.state.jobTwo.id;
    let dropoff_address = {
        postcode: document.querySelector('[name=dropoff_address_postcode_split]').value,
        house_number_or_name: document.querySelector('[name=dropoff_address_house_number_or_name_split]').value,
        address_line_1: document.querySelector('[name=dropoff_address_address_line_1_split]').value,
        address_line_2: document.querySelector('[name=dropoff_address_address_line_2_split]').value,
        address_line_3: document.querySelector('[name=dropoff_address_address_line_3_split]').value,
        town_city: document.querySelector('[name=dropoff_address_town_city_split]').value,
        county_area: document.querySelector('[name=dropoff_address_county_area_split]').value,
        country: document.querySelector('[name=dropoff_address_country_split]').value,
        opening_times: document.querySelector('[name=dropoff_address_opening_times_split]').value,
        compound_opening_times: document.querySelector('[name=dropoff_address_compound_opening_times_split]').value,
        contact_name: document.querySelector('[name=dropoff_address_contact_name_split]').value,
        contact_telephone_number: document.querySelector('[name=dropoff_address_contact_telephone_number_split]').value,
    };
    $.ajax({
      url: "/api/v1/portal/split-job/save-dropoff-address/"+jobId,
      data: {api_token: window.api_token,first_child:firstChildSplit,second_child:secondChildSplit,dropoff_address},
      cache: false,
      method: 'post',
      complete: function(response) {
        if (response.status == 200) {
          // ASSUME GOOD FOR NOW
          $('#infomodallabel').html('Success');
          $('#infomodal .modal-body').html('Dropoff address saved successfully.');
          $('#infomodal').modal();

          $('html, body,#job-splitter-modal').animate({
            scrollTop: $("#job-splitter-modal #react-component-g4-logistics-portal-job-splitter").offset().top - 100
          }, 1000);
        }
        else {
          $('#infomodallabel').html('Error');
          $('#infomodal .modal-body').html(
            response.responseText.replace(/\"/g,
              "")
          );
          $('#infomodal').modal();
        }
      }
    });
    return false;
  }
  
  render() {
    return (
      <div className="portal-job-splitter-blocks-container row no-padding">
        <div id="place-service-helper-div-split"></div>
        {(this.state.hasChildJobs == 0) ? 
        <div className="col-md-12 text-center">
          <button className="btn btn-info btn-lg" onClick={(e) => this.props.handleCreateSplitButtonClick(e, this.state.job.id)}>
            <i className="fa fa-strikethrough"></i>plit {this.state.hasChildJobs}
          </button>
        </div>
        : ''}
        <div className="col-md-6">
          <div className="col-md-12">
            <div className="portal-job-splitter-block portal-job-splitter-block-start">
              <div className="job-splitter-block-address-and-time">
                <div>Pickup Address: {this.state.pickupAddressOnOneLineChildOne}</div>
                <div>Pickup {this.state.pickupTimeChildOne}</div>
              </div>
              <div className="job-splitter-job-belongs-to-info">
                (<a href={"/jobs/view/"+this.state.jobOne.id}>Job#{this.state.jobOne.id}</a> pickup)
              </div>
            </div>
          </div>
          
          <div className="col-md-12">
            <div className="portal-job-splitter-block portal-job-splitter-block-end">
              <div className="job-splitter-block-address-and-time">
                <div>Dropoff {this.state.dropoffTimeChildOne}</div>
                <div>Dropoff Address: {this.state.dropoffAddressOnOneLineChildOne}</div>
              
                {(this.state.dropoffAddressOnOneLineChildOne == null) ? 
                  <div className="col-md-12 split-address-finder">
                    <h4>Dropoff Address</h4>
                    <div className="form-group address-finder">
                        <div id="dropoff_address_postcode_lookup_split">
                        </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-4">
                      <label htmlFor="dropoff_address_house_number_or_name_split">
                        House Number or Name:
                      </label>
                      </div>
                      <div className="col-md-8">
                      <input type="text" name="dropoff_address_house_number_or_name_split"
                        id="dropoff_address_house_number_or_name_split"
                        className="form-control form-control-lg" />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-4">
                      <label htmlFor="dropoff_address_address_line_1_split">
                        Address Line 1:
                      </label>
                      </div>
                      <div className="col-md-8">
                      <input type="text" name="dropoff_address_address_line_1_split"
                        id="dropoff_address_address_line_1_split"
                        className="form-control form-control-lg" />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-4">
                      <label htmlFor="dropoff_address_address_line_2_split">
                        Address Line 2:
                      </label>
                      </div>
                      <div className="col-md-8">
                      <input type="text" name="dropoff_address_address_line_2_split"
                        id="dropoff_address_address_line_2_split"
                        className="form-control form-control-lg" />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-4">
                      <label htmlFor="dropoff_address_address_line_3_split">
                        Address Line 3:
                      </label>
                      </div>
                      <div className="col-md-8">
                      <input type="text" name="dropoff_address_address_line_3_split"
                        id="dropoff_address_address_line_3_split"
                        className="form-control form-control-lg" />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_town_city_split">
                          Town/City:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input type="text" name="dropoff_address_town_city_split"
                          id="dropoff_address_town_city_split"
                          className="form-control form-control-lg" />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_county_area_split">
                          County/Area:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input type="text" name="dropoff_address_county_area_split"
                          id="dropoff_address_county_area_split"
                          className="form-control form-control-lg" />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-4">
                      <label htmlFor="dropoff_address_country_split">
                        Country:
                      </label>
                      </div>
                      <div className="col-md-8">
                      <input type="text" name="dropoff_address_country_split"
                        id="dropoff_address_country_split"
                        className="form-control form-control-lg" />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-4">
                      <label htmlFor="dropoff_address_postcode_split">
                        Postcode:
                      </label>
                      </div>
                      <div className="col-md-8">
                        <input type="text" name="dropoff_address_postcode_split"
                          id="dropoff_address_postcode_split"
                          className="form-control form-control-lg" />
                      </div>
                    </div>

                    <hr />

                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_opening_times_split">
                          Opening/Closing Times:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input type="text" name="dropoff_address_opening_times_split"
                              id="dropoff_address_opening_times_split"
                              placeholder="e.g. 9am to 11am, 1pm to 5pm"
                              className="form-control form-control-lg" />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_compound_opening_times_split">
                          Compound Opening/Closing Times:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input type="text" name="dropoff_address_compound_opening_times_split"
                              id="dropoff_address_compound_opening_times_split"
                              placeholder="e.g. 9am to 11am, 1pm to 5pm"
                              className="form-control form-control-lg" />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-4">
                        <label htmlFor="dropoff_address_contact_name_split">
                          Contact Name:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input type="text" name="dropoff_address_contact_name_split"
                              id="dropoff_address_contact_name_split"
                              className="form-control form-control-lg" />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-4">
                        <label
                          htmlFor="dropoff_address_contact_telephone_number_split">
                          Contact Telephone Number:
                        </label>
                      </div>
                      <div className="col-md-8">
                        <input
                          type="text"
                          name="dropoff_address_contact_telephone_number_split"
                          id="dropoff_address_contact_telephone_number_split"
                          className="form-control form-control-lg" />
                      </div>
                    </div>
                    <div className="text-center">
                      <button type="button" className="btn btn-success btn-lg" onClick={this.handleFirstChildAddressSave}>
                        Save Job#{this.state.jobOne.id} Dropoff Address
                      </button>
                    </div>
              </div>
                : ""}

              </div>
              <div className="job-splitter-job-belongs-to-info">
                (<a href={"/jobs/view/"+this.state.jobOne.id}>Job#{this.state.jobOne.id}</a> dropoff)
              </div>
            </div>
          </div>
          
        </div>
        <div className="col-md-6">
          
          <div className="col-md-12">
            <div className="portal-job-splitter-block portal-job-splitter-block-start">
              <div className="job-splitter-block-address-and-time">
                <div>Pickup Address: {this.state.pickupAddressOnOneLineChildTwo}</div>
                <div>Pickup {this.state.pickupTimeChildTwo}</div>
              </div>
              <div className="job-splitter-job-belongs-to-info">
                (<a href={"/jobs/view/"+this.state.jobTwo.id}>Job#{this.state.jobTwo.id}</a> pickup)
              </div>
            </div>
          </div>
          
          <div className="col-md-12">
            <div className="portal-job-splitter-block portal-job-splitter-block-end">
              <div className="job-splitter-block-address-and-time">
                <div>Dropoff {this.state.dropoffTimeChildTwo}</div>
                <div>Dropoff Address: {this.state.dropoffAddressOnOneLineChildTwo}</div>
              </div>
              <div className="job-splitter-job-belongs-to-info">
                (<a href={"/jobs/view/"+this.state.jobTwo.id}>Job#{this.state.jobTwo.id}</a> dropoff)
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
